import { render, staticRenderFns } from "./PolygonTransactions.vue?vue&type=template&id=6c8130a6"
import script from "./PolygonTransactions.vue?vue&type=script&lang=js"
export * from "./PolygonTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports